import { useState } from 'react';
import type { Id } from '../../../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: hook in src/pages/insurance/claim-form-editor/ requires four levels up

export function useClaimFormEditorState() {
  const [templateName, setTemplateName] = useState('');
  const [isDefault, setIsDefault] = useState(false);
  const [selectedTypeId, setSelectedTypeId] = useState<string>('none');
  const [isSaving, setIsSaving] = useState(false);

  function initFromTemplate(template: {
    name: string;
    isDefault: boolean;
    insuranceTypeId?: Id<'orgInsuranceTypes'>;
  }) {
    setTemplateName(template.name);
    setIsDefault(template.isDefault);
    setSelectedTypeId(template.insuranceTypeId ?? 'none');
  }

  return {
    templateName,
    setTemplateName,
    isDefault,
    setIsDefault,
    selectedTypeId,
    setSelectedTypeId,
    isSaving,
    setIsSaving,
    initFromTemplate,
  };
}
